import React from 'react';
import ViewInfoProcess from './ViewInfoProcess';

class InvestigationView extends React.Component {
    render() {
        return (
            <div className="content-2">
                <ViewInfoProcess canEdit={true} />
            </div>
        );
    }
}

export default InvestigationView;


// WEBPACK FOOTER //
// ./src/components/investigation/InvestigationView.js